var map = {
	"./demos/basic/index.ts": 48706,
	"./demos/children/index.ts": 81816,
	"./demos/layout/index.ts": 2601,
	"./demos/line/index.ts": 12930,
	"./demos/select/index.ts": 48868,
	"./demos/shape/index.ts": 46248
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72560;